// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__wodJ4","left":"StickyBox_left__3S8_P","right":"StickyBox_right__1Wcgw"};